module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"mail_or_name":"E-mail address or username","password":"Password","login":"Login","forgot_pass":"Forgot password?","keep_session":"Save login"},"de":{"mail_or_name":"E-Mail Adresse oder Nutzername","password":"Passwort","login":"Anmelden","forgot_pass":"Passwort vergessen?","keep_session":"Login speichern"}}')
  delete Component.options._Ctor
}
